import { Controller } from "stimulus";
import axios from "axios";
import $ from 'jquery';

const actions = {
  APPEND: "append",
  REPLACE: "replace",
  PREPEND: "prepend",
  REMOVE: "remove",
  UPDATE: "update"
};

export default class AppController extends Controller {
  axios = axios;
  elementPartial = null;
  targetPartial = null;

  connect() {
    const token = $('meta[name="csrf-token"]').attr("content");
    axios.defaults.headers.common["Accept"] = "text/html, application/xhtml+xml";
    axios.defaults.headers.common["X-CSRF-Token"] = token;
    this.axios = axios;
  }

  ctrl(name) {
    const element = document.querySelector(`[data-controller="${name}"]`);
    return this.application.getControllerForElementAndIdentifier(element, name);
  }

  processPartial(plainHtml) {
    if (plainHtml == null) return;
    const element = this.htmlToElement(plainHtml);
    const action = element.getAttribute("action");
    const target = element.getAttribute("target");
    const targetElement = document.getElementById(target);
    if (!Object.values(actions).includes(action)) return;
    if (target == null || targetElement == null) return;
    if (element.tagName != "STIMULUS") return;
    this.elementPartial = element;
    this.targetPartial = targetElement;

    switch (action) {
      case actions.APPEND:
        this.appendElement();
        break;
      case actions.PREPEND:
        this.prependElement();
        break;
      case actions.REPLACE:
        this.replaceElement();
        break;
      case actions.UPDATE:
        this.updateElement();
        break;
      case actions.REMOVE:
        this.removeElement();
        break;
    }
  }

  appendElement() {
    this.targetPartial.append(this.templateContent);
  }
  prependElement() {
    this.targetPartial.prepend(this.templateContent);
  }
  replaceElement() {
    this.targetPartial.replaceWith(this.templateContent);
  }
  updateElement() {
    this.targetPartial.innerHTML = "";
    this.targetPartial.append(this.templateContent);
  }
  removeElement() {
    this.targetPartial.remove();
  }

  htmlToElement(html) {
    const template = document.createElement("div");
    html = html.trim();
    template.innerHTML = html;
    return template.firstChild;
  }

  setLoading(app) {
    if(app.nodeType === Node.ELEMENT_NODE) return app.innerHTML = this.loadingElement;
    app.element.innerHTML = this.loadingElement;
  }

  setEmpty(app) {
    if(app.nodeType === Node.ELEMENT_NODE) return app.innerHTML = '';
    app.element.innerHTML = '';
  }

  get templateContent() {
    return this.templateElement.content;
  }

  get templateElement() {
    if (this.elementPartial.firstElementChild instanceof HTMLTemplateElement) {
      return this.elementPartial.firstElementChild;
    }
    throw new Error("First child element must be a <template> element");
  }

  get loadingElement() {
    return `<div class="loader"></div>`;
  }
}
